export const formatMaturityDate = (dayjs, maturityDate) => {
  if (!maturityDate) return '';
  return dayjs(maturityDate).utc().format('MMM D[,] YYYY');
};
